import React, { useMemo } from 'react';
import { Field, Form, Formik } from 'formik';
import { startCase, toUpper } from 'lodash';
import * as yup from 'yup';

import { Box } from 'shared/components/display';
import { InlineSocialMediaHandleInput, InlineTextInput } from 'shared/components/InlineInputs';

import { useIntl } from 'shared/lib/intl';
import { BrkfstUser } from 'shared/typings/user';
import { YUP_FIELDS } from 'shared/utilities/yupFieldUtility';

// fieldnames
const PORTFOLIO_LINK = 'portfolioLink';
const PORTFOLIO_LINK_PLACEHOLDER = 'portfolio link';
const INSTAGRAM = 'instagram';
const TIKTOK = 'tiktok';

const PORTFOLIO_LINK_UPPER = toUpper(startCase(PORTFOLIO_LINK));
const INSTAGRAM_UPPER = toUpper(INSTAGRAM);
const TIKTOK_UPPER = toUpper(TIKTOK);

interface Props {
  user: Pick<BrkfstUser, 'portfolioLink' | 'socialMediaInfo'>;
  onSubmit: (values: Values) => void;
}

interface Values {
  portfolioLink?: string;
  tiktok?: string;
}

const validationSchema: yup.SchemaOf<Values> = yup.object({
  [PORTFOLIO_LINK]: YUP_FIELDS.PORTFOLIO_LINK_OPTIONAL,
  [INSTAGRAM]: yup.string().nullable().instagramHandle(),
  [TIKTOK]: yup.string().nullable().tiktokHandle(),
});

const EditableCreatorInfo: React.FC<Props> = ({ user, onSubmit }) => {
  const { formatMessage } = useIntl();

  const initialValues: Values = useMemo(() => {
    return {
      [PORTFOLIO_LINK]: user?.portfolioLink || '',
      [INSTAGRAM]: user.socialMediaInfo?.instagram || '',
      [TIKTOK]: user.socialMediaInfo?.tiktok || '',
    };
  }, [user]);

  return (
    <Box className="editable-creator-info">
      <Formik<Values> validationSchema={validationSchema} onSubmit={onSubmit} initialValues={initialValues}>
        {() => (
          <Form>
            <Field
              name={PORTFOLIO_LINK}
              maxLength={512}
              component={InlineTextInput}
              placeholder={formatMessage(
                {
                  id: 'PLACEHOLDER_PROFILE',
                },
                { field: PORTFOLIO_LINK_PLACEHOLDER },
              )}
              label={PORTFOLIO_LINK_UPPER}
            />
            <Field
              name={INSTAGRAM}
              label={INSTAGRAM_UPPER}
              component={InlineSocialMediaHandleInput}
              placeholder="instagram_handle"
            />
            <Field
              name={TIKTOK}
              label={TIKTOK_UPPER}
              component={InlineSocialMediaHandleInput}
              placeholder="tiktok_handle"
            />
          </Form>
        )}
      </Formik>
    </Box>
  );
};

export default EditableCreatorInfo;
